const skillsData = {
  categories: [
    {
      id: 1,
      name: "Programming & Frameworks",
      skills: [
        { name: "Laravel", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/laravel/laravel-original.svg", color: "#FF2D20" },
        { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg", color: "#61DAFB" },
        { name: "Java", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg", color: "#007396" },
        { name: "C#", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg", color: "#239120" },
        { name: "C++", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg", color: "#00599C" },
        { name: "Android Studio", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg", color: "#3DDC84" },
        { name: "Tailwind CSS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg", color: "#06B6D4" }
      ]
    },
    {
      id: 2,
      name: "Databases & Tools",
      skills: [
        { name: "MySQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg", color: "#4479A1" },
        { name: "SQLite", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg", color: "#003B57" },
        { name: "Firebase", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg", color: "#FFCA28" },
        { name: "Git & GitHub", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/github/github-original.svg", color: "#181717", darkLogo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/github/github-original-wordmark.svg" }
      ]
    },
    {
      id: 3,
      name: "System & IT Skills",
      skills: [
        { name: "System Analysis & Design", icon: "layout" },
        { name: "Database Design (ERD & RDBMS)", icon: "database" },
        { name: "OCR Integration", icon: "scan" },
        { name: "Role-Based Access Control", icon: "shield" },
        { name: "IT Support & Maintenance", icon: "tool" },
        { name: "Hardware & Software Troubleshooting", icon: "wrench" }
      ]
    }
  ]
};

export default skillsData;
